module.exports = {
  radio_option: []
}



// WEBPACK FOOTER //
// ./src/components/Model/widgetAttr/radio.js